var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getRoomDisplayName } from './roomDisplayName';
import MomentUtils from '@date-io/moment';
import { Modal, ThemeProvider } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
//import { Modal } from '@mui/material';
import _, { groupBy, orderBy } from 'lodash';
import moment from 'moment';
import { SnackbarProvider, useSnackbar } from 'notistack';
import React, { createContext, useContext, useEffect, useMemo, useRef, useState } from 'react';
import Theme, { isGagraUI } from 'react-common/theme';
import { BrowserRouter as Router } from 'react-router-dom';
import { _T, formatString } from '../../../include/appI18n';
import { showErrorDialog } from '../../../include/common';
import { api } from '../../../include/network/network';
import { BackdropProvider } from '../../../include/react-components/BackdropProvider';
import ErrorBoundary from '../../../include/react-components/ErrorBoundary';
import { GlobalSpinnerProvider } from '../../../include/react-components/GlobalSpinnerProvider';
import { appUrl, formatMoney, openPaymentUrl } from '../../../include/utils';
import { PaymentForm } from '../../Payment/components/PaymentForm';
import { BookingCustomerType, TouristDocumentType } from '../types';
import { CustomerDetails } from './CustomerDetails';
import { BookingRemarkTemplates } from './BookingRemarkTemplates';
import { BusTourService } from './BusTourService';
import { ExcursionService } from './ExcursionService';
import { ExtraService } from './ExtraService';
import { FlightSchemeModal } from './FlightSchemeModal';
import { FlightService } from './FlightService';
import { HotelService } from './HotelService';
import { TourService } from './TourService';
import { TransferService } from './TransferService';
import { useAutofillSync } from './useAutofillSync';
import { useGagraHotelColumns } from './useGagraHotelColumns';
export function CartOrderContainer(props) {
    return (React.createElement(BackdropProvider, null,
        React.createElement(GlobalSpinnerProvider, null,
            React.createElement(ErrorBoundary, null,
                React.createElement(ThemeProvider, { theme: Theme },
                    React.createElement(SnackbarProvider, { maxSnack: 3, anchorOrigin: { vertical: 'top', horizontal: 'right' } },
                        React.createElement(MuiPickersUtilsProvider, { utils: MomentUtils },
                            React.createElement(Router, null,
                                React.createElement(CartOrder, Object.assign({}, props))))))))));
}
const fixBooking = (booking) => {
    var _a, _b;
    const customer = booking.customer || { type: BookingCustomerType.Individual };
    return (Object.assign(Object.assign({}, booking), { additionalRequirements: (_a = booking.additionalRequirements) !== null && _a !== void 0 ? _a : '', healthDeclarationChecked: (_b = booking.healthDeclarationChecked) !== null && _b !== void 0 ? _b : false, customer: Object.assign(Object.assign({}, customer), { docDate: customer.docDate ? moment(customer.docDate) : null, docExpirationDate: customer.docExpirationDate ? moment(customer.docExpirationDate) : null }), services: booking.services.map(s => (Object.assign(Object.assign({}, s), { tourists: s.tourists.map(t => (Object.assign(Object.assign({}, t), { docDate: t.docDate ? moment(t.docDate) : null, docExpirationDate: t.docExpirationDate ? moment(t.docExpirationDate) : null, birthDate: t.birthDate ? moment(t.birthDate) : null }))) }))) }));
};
const bookingAutoSaveDelayMs = 600;
const normalizeErrorField = (field) => {
    if (!field)
        return field;
    switch (field.toLowerCase()) {
        case 'birthdate':
            return 'birthDate';
        case 'docnumber':
            return 'docNumber';
        case 'docdate':
            return 'docDate';
        case 'docexpirationdate':
            return 'docExpirationDate';
        case 'middlename':
            return 'middleName';
        case 'doctype':
            return 'docType';
        case 'citizencountryid':
            return 'citizenCountryId';
        case 'flightcity':
            return 'flightCity';
        case 'flightno':
            return 'flightNo';
        case 'flighttime':
            return 'flightTime';
        case 'transfertime':
            return 'transferTime';
        default:
            return field;
    }
};
const normalizeErrors = (errors) => {
    var _a;
    if (!errors)
        return errors;
    return Object.assign(Object.assign({}, errors), { serviceErrors: (_a = errors.serviceErrors) === null || _a === void 0 ? void 0 : _a.map(e => (Object.assign(Object.assign({}, e), { field: normalizeErrorField(e.field) || e.field }))) });
};
const touristNameFields = ['surname', 'name', 'middleName'];
const commonTouristNameRegex = /^[A-Za-zА-Яа-яЁё \-]+$/;
const foreignPassportTouristNameRegex = /^[A-Za-z \-]+$/;
const formatDateOnlyForSave = (value) => {
    if (!value)
        return null;
    const date = moment(value);
    return date.isValid() ? date.format('YYYY-MM-DD') : null;
};
const serializeCustomerDatesForSave = (customer) => (Object.assign(Object.assign({}, customer), { docDate: formatDateOnlyForSave(customer.docDate), docExpirationDate: formatDateOnlyForSave(customer.docExpirationDate) }));
const serializeTouristDatesForSave = (tourist) => (Object.assign(Object.assign({}, tourist), { birthDate: formatDateOnlyForSave(tourist.birthDate), docDate: formatDateOnlyForSave(tourist.docDate), docExpirationDate: formatDateOnlyForSave(tourist.docExpirationDate) }));
const serializeBookingDatesForSave = (model) => (Object.assign(Object.assign({}, model), { customer: model.customer ? serializeCustomerDatesForSave(model.customer) : undefined, services: model.services.map(service => (Object.assign(Object.assign({}, service), { tourists: (service.tourists || []).map(serializeTouristDatesForSave) }))) }));
const stringifyBookingForSave = (model) => JSON.stringify(serializeBookingDatesForSave(model));
const getLocalTouristNameErrors = (model) => {
    const serviceErrors = [];
    model.services.forEach(service => {
        (service.tourists || []).forEach((tourist, touristIdx) => {
            const regex = tourist.docType == TouristDocumentType.RussianForeignPassport
                ? foreignPassportTouristNameRegex
                : commonTouristNameRegex;
            touristNameFields.forEach(field => {
                const value = tourist[field];
                if (value && !regex.test(value))
                    serviceErrors.push({ serviceId: service.id, touristIdx, field });
            });
        });
    });
    return serviceErrors.length ? { serviceErrors } : undefined;
};
const insurancePriceChangedMessage = 'Цена страховки изменилась';
const orderPriceChangedMessage = 'Стоимость заказа изменилась';
const getTouristFieldMessageKey = (serviceId, touristIdx, field) => `${serviceId}:${touristIdx}:${field}`;
const formatPriceDeltaText = (delta, currency, culture) => {
    const value = Number(delta);
    if (!Number.isFinite(value) || value === 0)
        return '';
    return `${value > 0 ? '+' : '-'} ${new Intl.NumberFormat(culture, {
        minimumFractionDigits: Math.abs(value) % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2,
    }).format(Math.abs(value))} ${currency || ''}`.trim();
};
const hasCostDifference = (response) => {
    const value = Number(response === null || response === void 0 ? void 0 : response.costDifference);
    return Number.isFinite(value) && value !== 0;
};
export const CartOrderContext = createContext(undefined);
export const CartOrderProvider = CartOrderContext.Provider;
export const useCartOrder = () => useContext(CartOrderContext);
const isHotelCompulsoryService = (service) => service.type == 'BookingHotelCompulsoryService' || !!service.compulsoryService;
const getServiceTagKey = (serviceTag) => { var _a; return (_a = serviceTag === null || serviceTag === void 0 ? void 0 : serviceTag.toString()) !== null && _a !== void 0 ? _a : ''; };
export function CartOrder(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var { booking: initialBooking } = _a, props = __rest(_a, ["booking"]);
    //const [{ }, actions] = useTourDescriptionStore(false);
    const { enqueueSnackbar } = useSnackbar();
    const [booking, setBooking] = useState(fixBooking(initialBooking));
    const [tourDescription, setTourDescription] = useState(props.tourDescription);
    const [penaltyCalculationRules, setPenaltyCalculationRules] = useState(props.penaltyCalculationRules);
    const [cancellationDenied, setCancellationDenied] = useState(props.cancellationDenied);
    const [paymentFormOpen, setPaymentFormOpen] = useState(false);
    const [topDetailedPriceOpen, setTopDetailedPriceOpen] = useState(false);
    const [bottomDetailedPriceOpen, setBottomDetailedPriceOpen] = useState(false);
    const pendingFlightPlaceUpdatesRef = useRef(undefined);
    const placeSelectionSkippedRef = useRef(false);
    const latestAutoSaveSnapshotRef = useRef(undefined);
    const autoSaveTimerRef = useRef(undefined);
    const autoSaveInProgressRef = useRef(false);
    const autoSaveRequestedRef = useRef(false);
    const autoSaveRefreshRequiredRef = useRef(false);
    const autoSaveSequenceRef = useRef(0);
    const autoSaveMountedRef = useRef(false);
    const localBookingEditVersionRef = useRef(0);
    const suppressAutoSaveForEditVersionRef = useRef(undefined);
    const lastBirthDateChangeRef = useRef(undefined);
    const [errors, setErrors] = useState({});
    const [touristFieldMessages, setTouristFieldMessages] = useState({});
    const commonErrors = useMemo(() => { var _a; return ((_a = errors.serviceErrors) === null || _a === void 0 ? void 0 : _a.filter(e => { var _a; return typeof e.serviceId != 'number' || ((_a = e.serviceId) !== null && _a !== void 0 ? _a : 0) < 0; }).map(e => e.field)) || []; }, [errors.serviceErrors]);
    const compulsoryServicesVersion = useMemo(() => {
        const compSvcs = booking.services.filter(isHotelCompulsoryService);
        if (!(compSvcs === null || compSvcs === void 0 ? void 0 : compSvcs.length))
            return undefined;
        let val = 41;
        for (const svc of compSvcs)
            val = val * 5 + svc.serviceVersion;
        return val.toString();
    }, [booking.services]);
    const services = useMemo(() => orderBy(booking.services, s => s.id), [booking.services]);
    const getTouristHash = (s) => { var _a, _b, _c, _d, _e, _f, _g; return `${(_a = s === null || s === void 0 ? void 0 : s.gender) !== null && _a !== void 0 ? _a : ''}::${(_b = s === null || s === void 0 ? void 0 : s.surname) !== null && _b !== void 0 ? _b : ''}::${(_c = s === null || s === void 0 ? void 0 : s.name) !== null && _c !== void 0 ? _c : ''}::${(_d = s === null || s === void 0 ? void 0 : s.middleName) !== null && _d !== void 0 ? _d : ''}::${(s === null || s === void 0 ? void 0 : s.birthDate) ? moment(s.birthDate).format('YYYYMMDD') : ''}::${(_e = s === null || s === void 0 ? void 0 : s.docType) !== null && _e !== void 0 ? _e : ''}::${(_f = s === null || s === void 0 ? void 0 : s.docNumber) !== null && _f !== void 0 ? _f : ''}::${(s === null || s === void 0 ? void 0 : s.docExpirationDate) ? moment(s.docExpirationDate).format('YYYYMMDD') : ''}::${(s === null || s === void 0 ? void 0 : s.docDate) ? moment(s.docDate).format('YYYYMMDD') : ''}::${(_g = s === null || s === void 0 ? void 0 : s.citizenCountryId) !== null && _g !== void 0 ? _g : ''}`; };
    const allTourists = useMemo(() => {
        const tourists = Object.values(groupBy(booking.services.map(s => s.tourists).flat().flat(), s => getTouristHash(s)));
        return tourists.filter(t => !!t).map(t => {
            var _a, _b, _c, _d;
            return (Object.assign(Object.assign({}, t[0]), { busPlaceId: undefined, busPlaceBookableId: undefined, busPlaceName: undefined, busPlaceBackId: undefined, busPlaceBackBookableId: undefined, busPlaceBackName: undefined, fullDescr: `${(_a = t[0].surname) !== null && _a !== void 0 ? _a : ''} ${(_b = t[0].name) !== null && _b !== void 0 ? _b : ''} ${(_c = t[0].middleName) !== null && _c !== void 0 ? _c : ''}${t[0].birthDate ? `, ${t[0].birthDate.format('DD.MM.YYYY')}` : ''}${t[0].docNumber || t[0].docExpirationDate || t[0].docDate ? ` (${t[0].docNumber} ${(_d = (t[0].docExpirationDate || t[0].docDate)) === null || _d === void 0 ? void 0 : _d.format('DD.MM.YYYY')})` : ''}` }));
        });
    }, [booking.services]);
    const refresh = (options) => __awaiter(this, void 0, void 0, function* () {
        var _k, _l;
        const { response, errors } = yield api('get', 'Cart/GetCartData', {});
        const hasServices = !!((_l = (_k = response === null || response === void 0 ? void 0 : response.booking) === null || _k === void 0 ? void 0 : _k.services) === null || _l === void 0 ? void 0 : _l.length);
        if (response === null || response === void 0 ? void 0 : response.booking) {
            if ((options === null || options === void 0 ? void 0 : options.canApply) && !options.canApply())
                return hasServices;
            if (options === null || options === void 0 ? void 0 : options.suppressAutoSave)
                suppressAutoSaveForEditVersionRef.current = localBookingEditVersionRef.current;
            setBooking(fixBooking(response.booking));
            autoSaveRefreshRequiredRef.current = false;
            if (response.tourDescription)
                setTourDescription(response.tourDescription);
            if (typeof response.cancellationDenied == 'boolean')
                setCancellationDenied(response.cancellationDenied);
            if (response.penaltyCalculationRules)
                setPenaltyCalculationRules(response.penaltyCalculationRules);
            //if (response.tourDescription)
            //    actions.updateDescription(response.tourDescription);
        }
        return hasServices;
    });
    const updateBooking = (updater) => {
        localBookingEditVersionRef.current++;
        setBooking(updater);
    };
    const setTouristFieldMessage = (serviceId, touristIdx, field, message) => {
        const key = getTouristFieldMessageKey(serviceId, touristIdx, field);
        setTouristFieldMessages(prev => {
            const next = Object.assign({}, prev);
            if (message)
                next[key] = message;
            else
                delete next[key];
            return next;
        });
    };
    const removeTouristFieldMessage = (serviceId, touristIdx, field) => setTouristFieldMessage(serviceId, touristIdx, field);
    const getTouristFieldMessage = (serviceId, touristIdx, field) => touristFieldMessages[getTouristFieldMessageKey(serviceId, touristIdx, field)];
    const showOrderPriceChangedNotification = (response) => {
        if (!(response === null || response === void 0 ? void 0 : response.priceChanged) || !hasCostDifference(response))
            return;
        const delta = formatPriceDeltaText(response.costDifference, response.currency, props.culture);
        enqueueSnackbar(React.createElement("span", null,
            orderPriceChangedMessage,
            delta ? React.createElement(React.Fragment, null,
                React.createElement("br", null),
                delta) : null), { variant: 'warning', autoHideDuration: 5000 });
    };
    const resolveTourFlightSchemeId = (flight) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (!flight)
            return 0;
        const schemeFromCalc = (_f = (_c = (_b = (_a = flight.calcFlights) === null || _a === void 0 ? void 0 : _a.find(f => { var _a; return ((_a = f.schemeId) !== null && _a !== void 0 ? _a : 0) > 0; })) === null || _b === void 0 ? void 0 : _b.schemeId) !== null && _c !== void 0 ? _c : (_e = (_d = flight.calcFlights) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.schemeId) !== null && _f !== void 0 ? _f : 0;
        return (_h = (_g = flight.schemeId) !== null && _g !== void 0 ? _g : schemeFromCalc) !== null && _h !== void 0 ? _h : 0;
    };
    const hasTourFlightScheme = (flight) => {
        return resolveTourFlightSchemeId(flight) > 0;
    };
    const isPrecheckFlightPlaceId = (placeId) => {
        return !!placeId && placeId.startsWith('_precheck_');
    };
    const hasRealFlightPlace = (place) => {
        var _a;
        if (!place)
            return false;
        if (isPrecheckFlightPlaceId(place.placeId))
            return false;
        return (((_a = place.bookableId) !== null && _a !== void 0 ? _a : 0) > 0) || !!place.placeId;
    };
    const findPendingFlightSchemeServiceId = (servicesToCheck) => {
        for (const svc of servicesToCheck) {
            if (svc.type === 'BookingFlightService') {
                const flightSvc = svc;
                const hasScheme = !!(flightSvc.schemeId || flightSvc.scheme);
                const missingSeats = (flightSvc.tourists || []).some(t => {
                    var _a;
                    const hasSeat = (t.flightPlaces || []).some(p => p.serviceId === flightSvc.id && hasRealFlightPlace(p));
                    if (hasSeat)
                        return false;
                    if (!t.flightPlaces || t.flightPlaces.length === 0)
                        return ((_a = t.busPlaceBookableId) !== null && _a !== void 0 ? _a : 0) <= 0;
                    return true;
                });
                if (hasScheme && missingSeats)
                    return flightSvc.id;
            }
            if (svc.type === 'BookingTourService') {
                const tourSvc = svc;
                const flights = (tourSvc.allTourServices || []).filter(ts => ts.type == 'flight');
                if (!flights.length)
                    continue;
                const flightsWithScheme = flights
                    .map(f => ({ flight: f, serviceId: f.serviceId, schemeId: resolveTourFlightSchemeId(f) }))
                    .filter(f => { var _a; return ((_a = f.schemeId) !== null && _a !== void 0 ? _a : 0) > 0 && !!f.serviceId; });
                if (!flightsWithScheme.length)
                    continue;
                const isBackward = (flight) => {
                    var _a, _b;
                    if (flight.flightDirection)
                        return flight.flightDirection === 2;
                    return ((_b = (_a = flight.calcFlights) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.type) === 2;
                };
                const missingSegment = (tourSvc.tourists || []).some(t => {
                    return flightsWithScheme.some(seg => {
                        var _a, _b;
                        const hasSeat = (t.flightPlaces || []).some(p => p.serviceId === seg.serviceId && hasRealFlightPlace(p));
                        if (hasSeat)
                            return false;
                        if (!t.flightPlaces || t.flightPlaces.length === 0) {
                            if (flightsWithScheme.length <= 2) {
                                const legacyFlight = seg.flight;
                                return isBackward(legacyFlight)
                                    ? ((_a = t.busPlaceBackBookableId) !== null && _a !== void 0 ? _a : 0) <= 0
                                    : ((_b = t.busPlaceBookableId) !== null && _b !== void 0 ? _b : 0) <= 0;
                            }
                        }
                        return true;
                    });
                });
                if (missingSegment)
                    return tourSvc.id;
            }
        }
        return undefined;
    };
    const hasPendingBusPlaceSelection = (servicesToCheck) => {
        var _a, _b;
        const busTours = servicesToCheck
            .filter(s => s.type === 'BookingTourService')
            .map(s => s)
            .filter(s => s.busPlaceSelectionAvailable && (s.allTourServices || []).some(ts => ts.type == 'busTransportation'));
        for (const svc of busTours) {
            const transportationCount = (svc.allTourServices || []).filter(ts => ts.type == 'busTransportation').length;
            const requiresBackward = transportationCount >= 2;
            for (const tourist of svc.tourists || []) {
                if (((_a = tourist.busPlaceBookableId) !== null && _a !== void 0 ? _a : 0) <= 0)
                    return true;
                if (requiresBackward && ((_b = tourist.busPlaceBackBookableId) !== null && _b !== void 0 ? _b : 0) <= 0)
                    return true;
            }
        }
        return false;
    };
    const applyBusValidationBypass = (model) => (Object.assign(Object.assign({}, model), { services: model.services.map(serviceModel => {
            const service = booking.services.find(s => s.id == serviceModel.id);
            if (!service || service.type !== 'BookingTourService')
                return serviceModel;
            const tourService = service;
            if (!tourService.busPlaceSelectionAvailable || !(tourService.allTourServices || []).some(ts => ts.type == 'busTransportation'))
                return serviceModel;
            const transportationCount = (tourService.allTourServices || []).filter(ts => ts.type == 'busTransportation').length;
            const requiresBackward = transportationCount >= 2;
            return Object.assign(Object.assign({}, serviceModel), { tourists: (serviceModel.tourists || []).map(t => {
                    var _a, _b;
                    return (Object.assign(Object.assign({}, t), { busPlaceBookableId: ((_a = t.busPlaceBookableId) !== null && _a !== void 0 ? _a : 0) > 0 ? t.busPlaceBookableId : 1, busPlaceBackBookableId: requiresBackward
                            ? (((_b = t.busPlaceBackBookableId) !== null && _b !== void 0 ? _b : 0) > 0 ? t.busPlaceBackBookableId : 1)
                            : t.busPlaceBackBookableId }));
                }) });
        }) }));
    const applyFlightValidationBypass = (model) => (Object.assign(Object.assign({}, model), { services: model.services.map(serviceModel => {
            const service = booking.services.find(s => s.id == serviceModel.id);
            if (!service)
                return serviceModel;
            const ensurePlaceForService = (tourist, flightServiceId) => {
                const existing = (tourist.flightPlaces || []).find(p => p.serviceId == flightServiceId && hasRealFlightPlace(p));
                if (existing)
                    return tourist;
                const retained = (tourist.flightPlaces || []).filter(p => p.serviceId != flightServiceId);
                return Object.assign(Object.assign({}, tourist), { flightPlaces: [
                        ...retained,
                        {
                            serviceId: flightServiceId,
                            placeId: `_precheck_${flightServiceId}`,
                            bookableId: 1,
                        },
                    ] });
            };
            if (service.type === 'BookingFlightService') {
                return Object.assign(Object.assign({}, serviceModel), { tourists: (serviceModel.tourists || []).map(t => ensurePlaceForService(t, service.id)) });
            }
            if (service.type === 'BookingTourService') {
                const tourService = service;
                const flightServiceIds = (tourService.allTourServices || [])
                    .filter(ts => ts.type == 'flight')
                    .map(ts => ts)
                    .map(f => ({ serviceId: f.serviceId, schemeId: resolveTourFlightSchemeId(f) }))
                    .filter(f => { var _a; return !!f.serviceId && ((_a = f.schemeId) !== null && _a !== void 0 ? _a : 0) > 0; })
                    .map(f => f.serviceId);
                if (!flightServiceIds.length)
                    return serviceModel;
                return Object.assign(Object.assign({}, serviceModel), { tourists: (serviceModel.tourists || []).map(t => {
                        let current = t;
                        for (const flightServiceId of flightServiceIds)
                            current = ensurePlaceForService(current, flightServiceId);
                        return current;
                    }) });
            }
            return serviceModel;
        }) }));
    const sanitizeModelFlightPlaces = (model) => (Object.assign(Object.assign({}, model), { services: model.services.map(serviceModel => (Object.assign(Object.assign({}, serviceModel), { placeSelectionExtras: undefined, tourists: (serviceModel.tourists || []).map(t => (Object.assign(Object.assign({}, t), { flightPlaces: (t.flightPlaces || []).filter(p => !isPrecheckFlightPlaceId(p.placeId)) }))) }))) }));
    const applyFlightPlaceUpdatesToModel = (model, updates) => {
        if (!(updates === null || updates === void 0 ? void 0 : updates.length))
            return model;
        const updatesByService = new Map(updates.map(update => [update.serviceId, update.tourists]));
        return Object.assign(Object.assign({}, model), { services: model.services.map(serviceModel => {
                const serviceUpdates = updatesByService.get(serviceModel.id);
                if (!(serviceUpdates === null || serviceUpdates === void 0 ? void 0 : serviceUpdates.length))
                    return serviceModel;
                const updatesByTourist = new Map(serviceUpdates.map(update => [update.personIdx, update.tourist]));
                return Object.assign(Object.assign({}, serviceModel), { tourists: (serviceModel.tourists || []).map((t, idx) => {
                        const touristUpdate = updatesByTourist.get(idx);
                        if (!touristUpdate)
                            return t;
                        return Object.assign(Object.assign({}, t), touristUpdate);
                    }) });
            }) });
    };
    const clearPlaceSelectionInModel = (model) => (Object.assign(Object.assign({}, model), { services: model.services.map(serviceModel => (Object.assign(Object.assign({}, serviceModel), { tourists: (serviceModel.tourists || []).map(t => (Object.assign(Object.assign({}, t), { busPlaceId: undefined, busPlaceName: undefined, busPlaceBookableId: undefined, busPlaceBackId: undefined, busPlaceBackName: undefined, busPlaceBackBookableId: undefined, flightPlaces: [] }))) }))) }));
    const makeBooking = (flightPlaceUpdates, options) => __awaiter(this, void 0, void 0, function* () {
        const skipPlaceSelectionPrompt = !!(options === null || options === void 0 ? void 0 : options.skipPlaceSelectionPrompt);
        placeSelectionSkippedRef.current = skipPlaceSelectionPrompt;
        pendingFlightPlaceUpdatesRef.current = (flightPlaceUpdates === null || flightPlaceUpdates === void 0 ? void 0 : flightPlaceUpdates.length) ? flightPlaceUpdates : undefined;
        let model = sanitizeModelFlightPlaces(getCartOrderBookingUpdateModel());
        if (flightPlaceUpdates === null || flightPlaceUpdates === void 0 ? void 0 : flightPlaceUpdates.length)
            model = applyFlightPlaceUpdatesToModel(model, flightPlaceUpdates);
        if (options === null || options === void 0 ? void 0 : options.clearPlaceSelection)
            model = clearPlaceSelectionInModel(model);
        const pendingBusPlaces = !skipPlaceSelectionPrompt && allowChoiceBusPlace && hasPendingBusPlaceSelection(booking.services);
        const pendingFlightPlaces = !skipPlaceSelectionPrompt && !(flightPlaceUpdates === null || flightPlaceUpdates === void 0 ? void 0 : flightPlaceUpdates.length) && !!findPendingFlightSchemeServiceId(booking.services);
        if (pendingBusPlaces || pendingFlightPlaces) {
            const precheckValid = yield validateCart(model, {
                suppressBusSchemeModal: true,
                suppressFlightSchemeModal: true,
            });
            if (!precheckValid)
                return;
            if (pendingFlightPlaces) {
                const pendingFlightServiceId = findPendingFlightSchemeServiceId(booking.services);
                document.dispatchEvent(new CustomEvent('flightSchemeModalRequested', { detail: { serviceId: pendingFlightServiceId } }));
                return;
            }
            document.dispatchEvent(new CustomEvent('busSchemeModalRequested', { detail: { source: 'cart-order' } }));
            return;
        }
        if (yield validateCart(model)) {
            if (props.configuration.payEnabled) {
                document.dispatchEvent(new CustomEvent('busSchemeModalRequestCancelled', { detail: { source: 'cart-order' } }));
                if (yield refresh())
                    setTimeout(() => setPaymentFormOpen(true), 100);
            }
            else
                continueBooking(model);
        }
        else {
        }
    });
    const continueBooking = (model, paymentParams) => __awaiter(this, void 0, void 0, function* () {
        let { response: res, errors } = yield api('post', 'Cart/MakeBooking', {
            bookingJson: JSON.stringify(Object.assign(Object.assign({}, serializeBookingDatesForSave(model)), { paymentSystem: paymentParams === null || paymentParams === void 0 ? void 0 : paymentParams.paymentSystem, paymentMethod: paymentParams === null || paymentParams === void 0 ? void 0 : paymentParams.paymentMethod, paymentAmount: paymentParams === null || paymentParams === void 0 ? void 0 : paymentParams.paymentAmount })),
        });
        if (!res)
            return;
        if ('response' in res) {
            if (res.paymentUrl) {
                openPaymentUrl(res.paymentUrl);
                return;
            }
            else if (res.progressUrl) {
                window.location.replace(res.progressUrl);
                return;
            }
            else
                res = res.response;
        }
        if (!res || 'response' in res)
            return;
        if (res.redirectUrl)
            window.location.replace(res.redirectUrl);
        else if (res.hasErrors) {
            setErrors(normalizeErrors(res) || {});
            setTimeout(() => {
                $(".row.tourist.error,.transfer .error").closest(".arrived").each(function (idx, elt) {
                    $(elt).collapse("show");
                });
                const container = document.querySelector('.error');
                if (container)
                    window.scrollTo({ top: container.offsetTop, behavior: 'smooth' });
            }, 200);
            showErrorDialog(res.genericError);
        }
        else {
            setErrors({});
            // старый вариант не нужен
        }
    });
    const validateCart = (model, options) => __awaiter(this, void 0, void 0, function* () {
        let requestModel = model;
        if (options === null || options === void 0 ? void 0 : options.ignoreBusPlaceSelection)
            requestModel = applyBusValidationBypass(requestModel);
        if (options === null || options === void 0 ? void 0 : options.ignoreFlightPlaceSelection)
            requestModel = applyFlightValidationBypass(requestModel);
        const localErrors = getLocalTouristNameErrors(requestModel);
        if (localErrors) {
            setErrors(localErrors);
            setTimeout(() => {
                $(".row.tourist.error,.transfer .error").closest(".arrived").each(function (idx, elt) {
                    $(elt).collapse("show");
                });
                const container = document.querySelector('.error');
                if (container)
                    window.scrollTo({ top: container.offsetTop, behavior: 'smooth' });
            }, 200);
            return false;
        }
        const { response, errors } = yield api('post', 'Cart/Validate', {
            bookingJson: stringifyBookingForSave(requestModel),
        });
        if (response === null || response === void 0 ? void 0 : response.hasErrors) {
            setErrors(normalizeErrors(response) || {});
            setTimeout(() => {
                $(".row.tourist.error,.transfer .error").closest(".arrived").each(function (idx, elt) {
                    $(elt).collapse("show");
                });
                const container = document.querySelector('.error');
                if (container)
                    window.scrollTo({ top: container.offsetTop, behavior: 'smooth' });
            }, 200);
            const isOpenFlightModal = (response === null || response === void 0 ? void 0 : response.action) == 1 || (response === null || response === void 0 ? void 0 : response.action) == 'OpenFlightModal';
            if (isOpenFlightModal) {
                document.dispatchEvent(new CustomEvent('openFlightModalRequested', {}));
                return false;
            }
            const isOpenFlightSchemeModal = (response === null || response === void 0 ? void 0 : response.action) == 3 || (response === null || response === void 0 ? void 0 : response.action) == 'OpenFlightSchemeModal';
            if (!(options === null || options === void 0 ? void 0 : options.suppressFlightSchemeModal) && isOpenFlightSchemeModal) {
                const pendingFlightServiceId = findPendingFlightSchemeServiceId(booking.services);
                document.dispatchEvent(new CustomEvent('flightSchemeModalRequested', { detail: { serviceId: pendingFlightServiceId } }));
                return false;
            }
            let message = response.genericError;
            if (message && response.searchRequest) {
                try {
                    const url = appUrl('/Tour', Object.assign(Object.assign({}, response.searchRequest), { autoReplace: 1 }));
                    message = formatString(message, [url]);
                }
                catch (_m) { }
            }
            showErrorDialog(message);
        }
        else {
            setErrors({});
            if (!(options === null || options === void 0 ? void 0 : options.suppressBusSchemeModal) && ((response === null || response === void 0 ? void 0 : response.action) == 2 || (response === null || response === void 0 ? void 0 : response.action) == 'OpenBusSchemeModal')) {
                document.dispatchEvent(new CustomEvent('busSchemeModalRequested', { detail: { source: 'cart-order' } }));
                return false;
            }
            if (!(options === null || options === void 0 ? void 0 : options.suppressFlightSchemeModal) && ((response === null || response === void 0 ? void 0 : response.action) == 3 || (response === null || response === void 0 ? void 0 : response.action) == 'OpenFlightSchemeModal')) {
                const pendingFlightServiceId = findPendingFlightSchemeServiceId(booking.services);
                document.dispatchEvent(new CustomEvent('flightSchemeModalRequested', { detail: { serviceId: pendingFlightServiceId } }));
                return false;
            }
            if ((response === null || response === void 0 ? void 0 : response.action) == 1 || (response === null || response === void 0 ? void 0 : response.action) == 'OpenFlightModal') {
                document.dispatchEvent(new CustomEvent('openFlightModalRequested', {}));
                return false;
            }
        }
        return !(response === null || response === void 0 ? void 0 : response.hasErrors);
    });
    const deleteService = (serviceId) => __awaiter(this, void 0, void 0, function* () {
        yield api('post', 'Cart/DeleteService', { serviceId });
        const hasServices = yield refresh();
        if (!hasServices) {
            window.location.reload();
            return false;
        }
        return true;
    });
    const buildCustomerForSave = () => {
        var _a, _b, _c, _d, _e;
        if (!booking.customer)
            return undefined;
        const customerType = (_a = booking.customer.type) !== null && _a !== void 0 ? _a : BookingCustomerType.Individual;
        const isTourist = customerType === BookingCustomerType.Tourist;
        const customer = {
            type: customerType,
            touristKey: isTourist ? (booking.customer.touristKey || null) : null,
            email: booking.customer.email,
            phone: booking.customer.phone,
        };
        if (!isTourist) {
            if (customerType === BookingCustomerType.Company) {
                customer.name = booking.customer.name;
                customer.inn = booking.customer.inn;
            }
            else {
                const docType = Number.parseInt(`${(_b = booking.customer.docType) !== null && _b !== void 0 ? _b : ''}`) || null;
                customer.surname = booking.customer.surname;
                customer.name = booking.customer.name;
                customer.middleName = booking.customer.middleName;
                customer.docType = docType;
                customer.docNumber = booking.customer.docNumber;
                const showIssue = docType === TouristDocumentType.RussianPassport || docType === TouristDocumentType.RussianBirthCertificate;
                const showExp = docType === TouristDocumentType.RussianForeignPassport || docType === TouristDocumentType.ForeignDocument;
                customer.docDate = showIssue ? (_c = booking.customer.docDate) !== null && _c !== void 0 ? _c : null : null;
                customer.docExpirationDate = showExp ? (_d = booking.customer.docExpirationDate) !== null && _d !== void 0 ? _d : null : null;
                customer.citizenCountryId = (_e = booking.customer.citizenCountryId) !== null && _e !== void 0 ? _e : null;
                if (customerType === BookingCustomerType.SoleProprietor)
                    customer.inn = booking.customer.inn;
            }
            customer.address = booking.customer.address;
        }
        return customer;
    };
    const getCartOrderBookingUpdateModel = () => ({
        anonymousContactEmail: booking.anonymousContactEmail,
        anonymousContactPhone: booking.anonymousContactPhone,
        additionalRequirements: booking.additionalRequirements,
        offer: booking.offer,
        policy: booking.policy,
        healthDeclarationChecked: booking.healthDeclarationChecked,
        customer: buildCustomerForSave(),
        services: booking.services.map(s => ({
            id: s.id,
            additionalRequirements: s.additionalRequirements,
            flightCity: s.flightCity,
            flightNo: s.flightNo,
            flightTime: s.flightTime,
            transferTime: s.transferTime,
            pickupPointId: s.pickupPointId,
            placeSelectionExtras: s.placeSelectionExtras,
            tourists: s.tourists || [],
        })),
    });
    const saveBookingSnapshot = (snapshot) => __awaiter(this, void 0, void 0, function* () {
        var _o;
        const { response, errors } = yield api('post', 'Cart/SaveCartBookingInfo', {
            bookingJson: stringifyBookingForSave(sanitizeModelFlightPlaces(snapshot.model)),
        });
        // A stale save can already have changed the server price. Keep the refresh pending
        // until a current snapshot is applied, even if the next save reports no price change.
        if (response === null || response === void 0 ? void 0 : response.priceChanged)
            autoSaveRefreshRequiredRef.current = true;
        if (((_o = latestAutoSaveSnapshotRef.current) === null || _o === void 0 ? void 0 : _o.sequence) !== snapshot.sequence || localBookingEditVersionRef.current !== snapshot.localEditVersion)
            return true;
        if (response === null || response === void 0 ? void 0 : response.priceChanged) {
            showOrderPriceChangedNotification(response);
            const lastBirthDateChange = lastBirthDateChangeRef.current;
            if (hasCostDifference(response) && (lastBirthDateChange === null || lastBirthDateChange === void 0 ? void 0 : lastBirthDateChange.localEditVersion) === snapshot.localEditVersion)
                setTouristFieldMessage(lastBirthDateChange.serviceId, lastBirthDateChange.personIdx, 'birthDate', insurancePriceChangedMessage);
        }
        if (response && (autoSaveRefreshRequiredRef.current || snapshot.compulsoryServicesVersion !== (response.compulsoryServicesVersion || undefined)))
            return yield refresh({
                suppressAutoSave: true,
                canApply: () => { var _a; return ((_a = latestAutoSaveSnapshotRef.current) === null || _a === void 0 ? void 0 : _a.sequence) === snapshot.sequence && localBookingEditVersionRef.current === snapshot.localEditVersion; },
            });
        return true;
    });
    const runBookingAutoSave = () => __awaiter(this, void 0, void 0, function* () {
        if (autoSaveInProgressRef.current) {
            autoSaveRequestedRef.current = true;
            return;
        }
        const snapshot = latestAutoSaveSnapshotRef.current;
        if (!snapshot)
            return;
        autoSaveInProgressRef.current = true;
        autoSaveRequestedRef.current = false;
        try {
            yield saveBookingSnapshot(snapshot);
        }
        finally {
            autoSaveInProgressRef.current = false;
            const latestSnapshot = latestAutoSaveSnapshotRef.current;
            if (autoSaveRequestedRef.current || (!!latestSnapshot && latestSnapshot.sequence !== snapshot.sequence && latestSnapshot.localEditVersion !== snapshot.localEditVersion)) {
                autoSaveRequestedRef.current = false;
                window.setTimeout(runBookingAutoSave, 0);
            }
        }
    });
    const scheduleBookingAutoSave = () => {
        latestAutoSaveSnapshotRef.current = {
            sequence: ++autoSaveSequenceRef.current,
            localEditVersion: localBookingEditVersionRef.current,
            model: getCartOrderBookingUpdateModel(),
            compulsoryServicesVersion,
        };
        const suppressedEditVersion = suppressAutoSaveForEditVersionRef.current;
        if (suppressedEditVersion !== undefined) {
            suppressAutoSaveForEditVersionRef.current = undefined;
            if (suppressedEditVersion === localBookingEditVersionRef.current)
                return;
        }
        if (!autoSaveMountedRef.current) {
            autoSaveMountedRef.current = true;
            return;
        }
        if (autoSaveTimerRef.current !== undefined)
            window.clearTimeout(autoSaveTimerRef.current);
        autoSaveTimerRef.current = window.setTimeout(() => {
            autoSaveTimerRef.current = undefined;
            void runBookingAutoSave();
        }, bookingAutoSaveDelayMs);
    };
    const saveTourist = (serviceId, personIdx, tourist, skipSimilarUpdating) => {
        const svc = booking.services.find(s => s.id == serviceId);
        if (!svc || !svc.tourists)
            return;
        const oldTourist = svc.tourists[personIdx];
        if (!oldTourist)
            return;
        if (Object.prototype.hasOwnProperty.call(tourist, 'birthDate')) {
            lastBirthDateChangeRef.current = { serviceId, personIdx, localEditVersion: localBookingEditVersionRef.current + 1 };
            removeTouristFieldMessage(serviceId, personIdx, 'birthDate');
        }
        updateBooking(prev => {
            const svc = prev.services.find(s => s.id == serviceId);
            const oldTourist = svc.tourists[personIdx];
            return Object.assign(Object.assign({}, prev), { services: prev.services.map(s => {
                    if (s.id == serviceId) {
                        return Object.assign(Object.assign({}, svc), { tourists: [
                                ...svc.tourists.slice(0, personIdx),
                                Object.assign(Object.assign({}, oldTourist), tourist),
                                ...svc.tourists.slice(personIdx + 1),
                            ] });
                    }
                    if (skipSimilarUpdating || svc.tourists.length != s.tourists.length)
                        return s;
                    return Object.assign(Object.assign({}, s), { tourists: [
                            ...s.tourists.slice(0, personIdx),
                            Object.assign(Object.assign(Object.assign({}, s.tourists[personIdx]), { busPlaceBookableId: s.tourists[personIdx].busPlaceBookableId, busPlaceId: s.tourists[personIdx].busPlaceId, busPlaceName: s.tourists[personIdx].busPlaceName, busPlaceBackBookableId: s.tourists[personIdx].busPlaceBackBookableId, busPlaceBackId: s.tourists[personIdx].busPlaceBackId, busPlaceBackName: s.tourists[personIdx].busPlaceBackName, flightPlaces: s.tourists[personIdx].flightPlaces }), (getTouristHash(oldTourist) == getTouristHash(s.tourists[personIdx]) ? tourist : {})),
                            ...s.tourists.slice(personIdx + 1),
                        ] });
                }) });
        });
    };
    const saveTourists = (serviceId, tourists, skipSimilarUpdating) => {
        const svc = booking.services.find(s => s.id == serviceId);
        if (!svc || !svc.tourists)
            return;
        if (!tourists.filter(t => !!svc.tourists[t.personIdx]).length)
            return;
        const birthDateChange = tourists.find(t => Object.prototype.hasOwnProperty.call(t.tourist, 'birthDate'));
        if (birthDateChange) {
            lastBirthDateChangeRef.current = { serviceId, personIdx: birthDateChange.personIdx, localEditVersion: localBookingEditVersionRef.current + 1 };
            removeTouristFieldMessage(serviceId, birthDateChange.personIdx, 'birthDate');
        }
        updateBooking(prev => {
            const svc = prev.services.find(s => s.id == serviceId);
            return Object.assign(Object.assign({}, prev), { services: prev.services.map(s => {
                    if (s.id == serviceId) {
                        return Object.assign(Object.assign({}, svc), { tourists: [
                                ...svc.tourists.map((t, ti) => {
                                    const entry = tourists.find(t => t.personIdx == ti);
                                    if (!(entry === null || entry === void 0 ? void 0 : entry.tourist))
                                        return t;
                                    return Object.assign(Object.assign({}, t), entry.tourist);
                                }),
                            ] });
                    }
                    if (skipSimilarUpdating || svc.tourists.length != s.tourists.length)
                        return s;
                    return Object.assign(Object.assign({}, s), { tourists: s.tourists.map((t, ti) => {
                            const entry = tourists.find(t => t.personIdx == ti);
                            if (!(entry === null || entry === void 0 ? void 0 : entry.tourist))
                                return t;
                            const oldTourist = svc.tourists[entry.personIdx];
                            return Object.assign(Object.assign(Object.assign({}, t), (getTouristHash(oldTourist) == getTouristHash(t) ? entry.tourist : {})), { busPlaceBookableId: t.busPlaceBookableId, busPlaceId: t.busPlaceId, busPlaceName: t.busPlaceName, busPlaceBackBookableId: t.busPlaceBackBookableId, busPlaceBackId: t.busPlaceBackId, busPlaceBackName: t.busPlaceBackName, flightPlaces: t.flightPlaces });
                        }) });
                }) });
        });
    };
    const saveService = (serviceId, service) => {
        const svc = booking.services.find(s => s.id == serviceId);
        if (!svc)
            return;
        updateBooking(prev => {
            const svc = prev.services.find(s => s.id == serviceId);
            return Object.assign(Object.assign({}, prev), { services: prev.services.map(s => s.id == serviceId ? Object.assign(Object.assign({}, svc), service) : s) });
        });
    };
    const saveCommonData = (data) => {
        updateBooking(prev => (Object.assign(Object.assign({}, prev), data)));
    };
    const saveCustomerData = (data) => {
        updateBooking(prev => (Object.assign(Object.assign({}, prev), { customer: Object.assign(Object.assign({}, (prev.customer || { type: BookingCustomerType.Individual })), data) })));
    };
    useEffect(() => {
        scheduleBookingAutoSave();
    }, [booking.services, booking.offer, booking.policy, booking.anonymousContactEmail, booking.anonymousContactPhone, booking.additionalRequirements, booking.healthDeclarationChecked, booking.customer]);
    useEffect(() => () => {
        if (autoSaveTimerRef.current !== undefined)
            window.clearTimeout(autoSaveTimerRef.current);
    }, []);
    const currencyChangeHandler = (e) => {
        e.preventDefault();
        const event = new CustomEvent('currencychange2', {
            cancelable: true,
            detail: Object.assign({}, e.detail)
        });
        document.dispatchEvent(event);
        refresh();
    };
    useEffect(() => {
        document.addEventListener('currencychange', currencyChangeHandler);
        return () => {
            document.removeEventListener('currencychange', currencyChangeHandler);
        };
    }, []);
    const removeTouristError = (serviceId, touristIdx, field) => {
        setErrors(prev => {
            var _a;
            return (Object.assign(Object.assign({}, prev), { serviceErrors: (_a = prev.serviceErrors) === null || _a === void 0 ? void 0 : _a.filter(e => !(e.serviceId === serviceId && e.touristIdx === touristIdx && e.field === field)) }));
        });
    };
    const removeServiceError = (serviceId, field) => {
        setErrors(prev => {
            var _a;
            return (Object.assign(Object.assign({}, prev), { serviceErrors: (_a = prev.serviceErrors) === null || _a === void 0 ? void 0 : _a.filter(e => !(e.serviceId === serviceId && e.touristIdx === undefined && e.field === field)) }));
        });
    };
    const removeCommonError = (field) => {
        setErrors(prev => {
            var _a;
            return (Object.assign(Object.assign({}, prev), { serviceErrors: (_a = prev.serviceErrors) === null || _a === void 0 ? void 0 : _a.filter(e => !((e.serviceId === undefined || e.serviceId === null || e.serviceId < 0) && e.touristIdx === undefined && e.field === field)) }));
        });
    };
    const contactAutofillSync = useAutofillSync(root => {
        var _a, _b;
        const email = (_a = root.querySelector('[name="contact-email"]')) === null || _a === void 0 ? void 0 : _a.value;
        const phone = (_b = root.querySelector('[name="contact-phone"]')) === null || _b === void 0 ? void 0 : _b.value;
        const changes = {};
        if (email !== undefined && email != booking.anonymousContactEmail) {
            changes.anonymousContactEmail = email;
            if (email)
                removeCommonError('contact-email');
        }
        if (phone !== undefined && phone != booking.anonymousContactPhone) {
            changes.anonymousContactPhone = phone;
            if (phone)
                removeCommonError('contact-phone');
        }
        if (Object.keys(changes).length)
            saveCommonData(changes);
    });
    const addTouristError = (serviceId, touristIdx, field) => {
        setErrors(prev => {
            var _a;
            return (Object.assign(Object.assign({}, prev), { serviceErrors: [
                    ...(((_a = prev.serviceErrors) === null || _a === void 0 ? void 0 : _a.filter(e => !(e.serviceId === serviceId && e.touristIdx === touristIdx && e.field === field))) || []),
                    { field, touristIdx, serviceId },
                ] }));
        });
    };
    const addServiceError = (serviceId, field) => {
        setErrors(prev => {
            var _a;
            return (Object.assign(Object.assign({}, prev), { serviceErrors: [
                    ...(((_a = prev.serviceErrors) === null || _a === void 0 ? void 0 : _a.filter(e => !(e.serviceId === serviceId && e.touristIdx === undefined && e.field === field))) || []),
                    { field, serviceId },
                ] }));
        });
    };
    const addCommonError = (field) => {
        setErrors(prev => {
            var _a;
            return (Object.assign(Object.assign({}, prev), { serviceErrors: [
                    ...(((_a = prev.serviceErrors) === null || _a === void 0 ? void 0 : _a.filter(e => !((e.serviceId === undefined || e.serviceId === null || e.serviceId < 0) && e.touristIdx === undefined && e.field === field))) || []),
                    { field, serviceId: -1 },
                ] }));
        });
    };
    const allowChoiceBusPlace = useMemo(() => {
        const hasBusSelection = services
            .filter(s => s.type == 'BookingTourService')
            .map(s => s)
            .some(s => s.allTourServices.filter(ts => ts.type == 'busTransportation').length > 0 && s.busPlaceSelectionAvailable);
        const hasFlightSelection = services
            .filter(s => s.type == 'BookingFlightService')
            .map(s => s)
            .some(s => !!(s.schemeId || s.scheme));
        const hasTourFlightSelection = services
            .filter(s => s.type == 'BookingTourService')
            .map(s => s)
            .some(s => (s.allTourServices || []).some(ts => ts.type == 'flight' && hasTourFlightScheme(ts)));
        return hasBusSelection || hasFlightSelection || hasTourFlightSelection;
    }, [services]);
    const commissionServicesCost = useMemo(() => _.sumBy(booking.services.filter(s => s.commissionPercent > 0), s => s.priceInBookingCurrency), [booking]);
    const nonCommissionServicesCost = useMemo(() => _.sumBy(booking.services.filter(s => s.commissionPercent <= 0), s => s.priceInBookingCurrency), [booking]);
    const commissionPercent = commissionServicesCost == 0 ? 0 : booking.commission / commissionServicesCost * 100;
    const isAnon = props.configuration.isAnonymousBookingAllowed && props.user.isAnonymous;
    const showContactDetails = isAnon || props.configuration.agencyCartPhoneRequired || !props.configuration.optionalTouristFieldsConfig.email || !props.configuration.optionalTouristFieldsConfig.phone;
    const showPolicies = (props.user.isAnonymous || props.user.isIndividual) && props.configuration.cartIndividualShowPoliciesFlags && (props.configuration.cartPolicyUrl || props.configuration.cartOfferUrl);
    const healthDeclarationService = useMemo(() => {
        var _a;
        const services = (_a = tourDescription === null || tourDescription === void 0 ? void 0 : tourDescription.priceItem) === null || _a === void 0 ? void 0 : _a.allServices;
        if (!services)
            return undefined;
        return services.find(s => (s === null || s === void 0 ? void 0 : s.typeId) == 7 && (s === null || s === void 0 ? void 0 : s.externalProviderId) > 0 && (s === null || s === void 0 ? void 0 : s.healthDeclarationText));
    }, [tourDescription]);
    const healthDeclarationRequired = useMemo(() => {
        var _a;
        const services = (_a = tourDescription === null || tourDescription === void 0 ? void 0 : tourDescription.priceItem) === null || _a === void 0 ? void 0 : _a.allServices;
        if (!services)
            return false;
        return services.some(s => (s === null || s === void 0 ? void 0 : s.typeId) == 7 && (s === null || s === void 0 ? void 0 : s.externalProviderId) > 0 && (s === null || s === void 0 ? void 0 : s.healthDeclarationRequired));
    }, [tourDescription]);
    const showPoliciesContainer = showPolicies || !!healthDeclarationService;
    const hasExternalCancellationConditions = useMemo(() => {
        const hotelServices = booking.services.filter(s => s.type == 'BookingHotelService');
        const hasExternalHotels = hotelServices.some(s => { var _a, _b; return ((_b = (_a = s.hotelPrice) === null || _a === void 0 ? void 0 : _a.externalProviderId) !== null && _b !== void 0 ? _b : 0) > 0 || !!s.externalHotelService; });
        const tourServices = booking.services.filter(s => s.type == 'BookingTourService');
        const hasExternalTourHotels = tourServices.some(t => { var _a; return (_a = t.allTourServices) === null || _a === void 0 ? void 0 : _a.some(s => s.type == 'hotel' && s.externalProviderId > 0); });
        return hasExternalHotels || hasExternalTourHotels;
    }, [booking.services]);
    const showCancellationConditions = useMemo(() => {
        const showOnlyExternal = !!props.configuration.showHotelCancellationConditionOnlyForExternalServices;
        return !showOnlyExternal || hasExternalCancellationConditions;
    }, [hasExternalCancellationConditions, props.configuration.showHotelCancellationConditionOnlyForExternalServices]);
    const showPaymentAndCancellationConditionsInConditionCol = !!props.configuration.showPaymentAndCancellationConditionsInConditionCol;
    const cancellationConditionsButtonClass = showPaymentAndCancellationConditionsInConditionCol ? 'pay-and-cancel-conditions' : 'cancel-conditions';
    const cancellationConditionsLabel = showPaymentAndCancellationConditionsInConditionCol ? _T.PAYMENT_AND_CANCELLATION_CONDITIONS : _T.CANCELLATION_CONDITIONS;
    const tourSearchConditionsHash = useMemo(() => { var _a, _b; return (_b = (_a = tourDescription === null || tourDescription === void 0 ? void 0 : tourDescription.priceItem) === null || _a === void 0 ? void 0 : _a.servicesHash) !== null && _b !== void 0 ? _b : ''; }, [tourDescription]);
    const tourServices = useMemo(() => booking.services.filter(s => s.type == 'BookingTourService'), [booking.services]);
    const hotelServices = useMemo(() => booking.services.filter(s => s.type == 'BookingHotelService'), [booking.services]);
    useGagraHotelColumns(hotelServices);
    const transferServices = useMemo(() => booking.services.filter(s => s.type == 'BookingTransferService'), [booking.services]);
    const flightServices = useMemo(() => booking.services.filter(s => s.type == 'BookingFlightService'), [booking.services]);
    const excursionServices = useMemo(() => booking.services.filter(s => s.type == 'BookingExcursionService'), [booking.services]);
    const extraServices = useMemo(() => booking.services.filter(s => s.type == 'BookingExtraService'), [booking.services]);
    const displayFlightAsTransportation = useMemo(() => { var _a; return !!((_a = props.configuration.flightConfiguration) === null || _a === void 0 ? void 0 : _a.displayFlightAsTransportation); }, [props.configuration.flightConfiguration]);
    const compulsoryServices = useMemo(() => booking.services.filter(isHotelCompulsoryService), [booking.services]);
    const compulsoryServicesByHotel = useMemo(() => groupBy(compulsoryServices, s => getServiceTagKey(s.serviceTag)), [compulsoryServices]);
    const detailedPriceHeaders = useMemo(() => (_T.BOOKING_CANCEL_TOTAL || '').split(',').map(x => x.trim()), []);
    useEffect(() => {
        var _a, _b, _c, _d;
        window.__showPaymentAndCancellationConditionsInConditionCol = showPaymentAndCancellationConditionsInConditionCol;
        window.__paymentAndCancellationConditionsModel = {
            booking: {
                prepaymentPercent: (_a = booking.prepaymentPercent) !== null && _a !== void 0 ? _a : 25,
                prepaymentDate: (_b = booking.prepaymentDate) !== null && _b !== void 0 ? _b : '',
                paymentDate: (_c = booking.paymentDate) !== null && _c !== void 0 ? _c : '',
            },
            cancellationDenied: !!cancellationDenied,
            penaltyCalculationRules: penaltyCalculationRules || [],
        };
        const cancellationStrings = (_d = window.strings) === null || _d === void 0 ? void 0 : _d.cancellation;
        if (cancellationStrings) {
            cancellationStrings.bookingCancelTitle = cancellationDenied ? (_T.HOTEL_NON_CANCEL_TITLE || cancellationStrings.conditions || _T.CANCELLATION_CONDITIONS) : (cancellationStrings.conditions || _T.CANCELLATION_CONDITIONS);
            cancellationStrings.areYouSure = _T.CANCELLATION_ARE_YOU_SURE || cancellationStrings.areYouSure;
        }
    }, [
        booking.paymentDate,
        booking.prepaymentDate,
        booking.prepaymentPercent,
        cancellationDenied,
        penaltyCalculationRules,
        showPaymentAndCancellationConditionsInConditionCol
    ]);
    const isExtendedCartPageDesign = !!props.configuration.useExtendedCartPageDesign;
    function renderStandaloneServiceGroup(items, renderService) {
        if (items.length == 0)
            return null;
        const content = items.map(renderService);
        return isExtendedCartPageDesign
            ? React.createElement("div", { className: "hotel-body my-4" }, content)
            : React.createElement(React.Fragment, null, content);
    }
    const bookingActionDisabled = (!props.configuration.isAnonymousBookingAllowed && !props.user.isAuthenticated) || props.configuration.isAgentContractExpired || !props.configuration.isBookingAvailableNow || !booking.cost;
    const showExtendedConditions = booking.prepayment > 0 || !!booking.paymentDate || showCancellationConditions;
    const formatCommissionPercent = (value) => new Intl.NumberFormat(props.culture, { maximumFractionDigits: 2 }).format(value);
    const renderDetailedPriceSummaryRows = () => (React.createElement(React.Fragment, null,
        props.user.isAgent ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "value-single" },
                React.createElement("span", null,
                    _T.BOOKING_PARTNER_COMMISSION,
                    ":"),
                React.createElement("span", null,
                    formatCommissionPercent(commissionPercent),
                    " %")),
            React.createElement("div", { className: "value-single" },
                React.createElement("span", null,
                    _T.BOOKING_COMMISSION_AMOUNT,
                    ":"),
                React.createElement("span", null,
                    formatMoney(booking.commission, { currency: booking.currency.name }),
                    " ",
                    booking.currency.name,
                    !props.configuration.currencySwitchEnabled && booking.commissionRub ? ` (${booking.commissionRub} RUB)` : '')))) : null,
        React.createElement("div", { className: "value-single" },
            React.createElement("span", null,
                _T.BOOKING_TOTAL_TO_PAY,
                ":"),
            React.createElement("span", null,
                formatMoney(booking.sumToPay, { currency: booking.currency.name }),
                " ",
                booking.currency.name,
                !props.configuration.currencySwitchEnabled && booking.sumToPayRub ? ` (${booking.sumToPayRub} RUB)` : '')),
        booking.prepayment > 0 ? (React.createElement("div", { className: "value-single" },
            React.createElement("span", null,
                _T.BOOKING_PREPAY,
                ":"),
            React.createElement("span", null,
                formatMoney(booking.prepayment, { currency: booking.currency.name }),
                " ",
                booking.currency.name,
                !props.configuration.currencySwitchEnabled && booking.prepaymentRub ? ` (${booking.prepaymentRub} RUB)` : ''))) : null));
    const additionalRequirementsBlock = (React.createElement("div", { className: "contact-details", id: "booking-add-req" },
        React.createElement("h3", null, _T.COMMON_ADDITIONAL_REQUIREMENTS),
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-md-6 col-xs-12" },
                React.createElement("div", { className: "form-grop" },
                    React.createElement("textarea", { className: "form-control add-req w-100", maxLength: 250, rows: 4, cols: 4, value: (_b = booking.additionalRequirements) !== null && _b !== void 0 ? _b : '', onChange: e => saveCommonData({ additionalRequirements: e.target.value }) }))),
            React.createElement("div", { className: "col-md-4 col-xs-12" },
                React.createElement("p", null,
                    "* ",
                    _T.COMMON_ADDITIONAL_REQUIREMENTS_COMMENT)))));
    const bookingRemarkBlock = tourServices.length > 0 ? (React.createElement(BookingRemarkTemplates, { additionalRequirements: booking.additionalRequirements, remarkTemplates: props.configuration.remarkTemplates, onChange: additionalRequirements => saveCommonData({ additionalRequirements }) })) : null;
    const customerDetailsBlock = props.configuration.cartShowCustomerBlock ? React.createElement(CustomerDetails, { booking: booking, configuration: props.configuration, onCustomerChange: saveCustomerData }) : null;
    const contactDetailsBlock = showContactDetails ? (React.createElement("div", Object.assign({ ref: contactAutofillSync.rootRef }, contactAutofillSync.autofillProps, { className: "contact-details ajax-replace react-cart-autofill-scope", id: "contact-details-wrapper" }),
        React.createElement("h3", null, _T.COMMON_CONTACT_DETAILS),
        React.createElement("div", null,
            React.createElement("div", { className: "inputs ajax-replace" },
                (isAnon || !props.configuration.optionalTouristFieldsConfig.email) ?
                    React.createElement("div", { className: `form-group contact-email ${commonErrors.includes('contact-email') ? 'error' : ''}` },
                        React.createElement("label", null, _T.COMMON_EMAIL),
                        React.createElement("input", { type: "email", name: "contact-email", className: `form-control`, onChange: e => {
                                saveCommonData({ anonymousContactEmail: e.target.value });
                                if (e.target.value)
                                    removeCommonError('contact-email');
                            }, value: booking.anonymousContactEmail, placeholder: _T.COMMON_EMAIL })) : null,
                React.createElement("div", { className: `form-group contact-phone ${commonErrors.includes('contact-phone') ? 'error' : ''}` },
                    React.createElement("label", null, _T.COMMON_PHONE),
                    React.createElement("input", { type: "text", name: "contact-phone", className: `form-control`, onChange: e => {
                            saveCommonData({ anonymousContactPhone: e.target.value });
                            if (e.target.value)
                                removeCommonError('contact-phone');
                        }, value: booking.anonymousContactPhone, placeholder: _T.COMMON_PHONE }))),
            isAnon ?
                React.createElement("div", { className: "hint align-self-center" },
                    React.createElement("div", { className: "form-group align-content-center mr-4" },
                        React.createElement("p", { className: "text-uppercase" }, _T.COMMON_OR)),
                    React.createElement("div", { className: "cart-login-btns-cintainer" },
                        React.createElement("a", { style: { width: 160 }, className: "btn btn-orange loginUrl", href: appUrl('/Home/Login') }, _T.LOGON_TO_ENTER),
                        React.createElement("a", { className: "btn-link ml-0 loginUrl", href: appUrl('/Home/RecoverPassword') }, _T.PASSWORD_RECOVERY_FORM_HEADER))) : null))) : null;
    const policiesBlock = showPoliciesContainer ? (React.createElement("div", { className: "ajax-replace", id: "policies-container" },
        showPolicies && props.configuration.cartPolicyUrl ? React.createElement("div", { className: `form-check policy ${commonErrors.includes('policy') ? 'error' : ''}` },
            React.createElement("input", { className: "form-check-input", type: "checkbox", id: "policy", checked: booking.policy, onChange: e => {
                    updateBooking(Object.assign(Object.assign({}, booking), { policy: e.target.checked }));
                    if (e.target.checked)
                        removeCommonError('policy');
                } }),
            React.createElement("label", { className: "form-check-label", htmlFor: "policy" }, _T.CART_ACCEPT),
            " ",
            React.createElement("a", { href: props.configuration.cartPolicyUrl.includes('://') ? props.configuration.cartPolicyUrl : appUrl(props.configuration.cartPolicyUrl), target: "_blank" }, _T.CART_ACCEPT_PRIVATE_POLICY),
            React.createElement("span", { className: "text-danger" }, "*")) : null,
        showPolicies && props.configuration.cartOfferUrl ? React.createElement("div", { className: `form-check offer ${commonErrors.includes('offer') ? 'error' : ''}` },
            React.createElement("input", { className: "form-check-input", type: "checkbox", id: "offer", checked: booking.offer, onChange: e => {
                    updateBooking(Object.assign(Object.assign({}, booking), { offer: e.target.checked }));
                    if (e.target.checked)
                        removeCommonError('offer');
                } }),
            React.createElement("label", { className: "form-check-label", htmlFor: "offer" }, _T.CART_ACCEPT),
            " ",
            React.createElement("a", { href: props.configuration.cartOfferUrl.includes('://') ? props.configuration.cartOfferUrl : appUrl(props.configuration.cartOfferUrl), target: "_blank" }, _T.CART_ACCEPT_OFFER),
            React.createElement("span", { className: "text-danger" }, "*")) : null,
        healthDeclarationService ? React.createElement(React.Fragment, null,
            React.createElement("div", { className: `form-check health-declaration ${commonErrors.includes('health-declaration') ? 'error' : ''}` },
                React.createElement("input", { className: "form-check-input", type: "checkbox", id: "health-declaration", checked: !!booking.healthDeclarationChecked, onChange: e => {
                        updateBooking(Object.assign(Object.assign({}, booking), { healthDeclarationChecked: e.target.checked }));
                        if (e.target.checked)
                            removeCommonError('health-declaration');
                    } }),
                React.createElement("span", null,
                    React.createElement("label", { className: "form-check-label health-declaration-label", htmlFor: "health-declaration" }, _T.CART_ACCEPT),
                    React.createElement("span", { id: "healthCheckUrl" }, _T.CART_ACCEPT_COVID_HEALTH_CHECK)),
                healthDeclarationRequired ? React.createElement("span", { className: "text-danger" }, "*") : null),
            React.createElement("div", { role: "dialog", id: "healthDeclarationDialog", className: "modal fade" },
                React.createElement("div", { className: "modal-dialog modal-lg modal-xl" },
                    React.createElement("div", { className: "modal-content custom-modal-content" },
                        React.createElement("div", { className: "d-flex" },
                            React.createElement("h2", { className: "flex-1" }, healthDeclarationService === null || healthDeclarationService === void 0 ? void 0 : healthDeclarationService.healthDeclarationAdditionalInfo),
                            React.createElement("div", { className: "dismisser px-3", "data-dismiss": "modal" }, "\u00D7")),
                        React.createElement("pre", null, healthDeclarationService === null || healthDeclarationService === void 0 ? void 0 : healthDeclarationService.healthDeclarationText))))) : null)) : null;
    const cancellationConditionsBlock = (React.createElement("div", { id: "cancellationConditions", className: "ajax-replace dont-show" }, showCancellationConditions ? (React.createElement("div", { className: "table-responsive" },
        React.createElement("table", { className: "table" },
            React.createElement("tr", null, cancellationDenied ? (React.createElement("td", { className: "text-normal orange-text ajax-replace", id: "cancelPolicyDescr", colSpan: 4 },
                React.createElement("span", null, _T.HOTEL_NON_CANCEL_TITLE),
                React.createElement("span", { dangerouslySetInnerHTML: { __html: _T.HOTEL_NON_CANCEL_CONDITIONS } }))) : (React.createElement(React.Fragment, null,
                React.createElement("td", { className: "text-normal ajax-replace", id: "cancelPolicyDescr" }, !(penaltyCalculationRules === null || penaltyCalculationRules === void 0 ? void 0 : penaltyCalculationRules.length) ? (React.createElement("span", null, _T.CANCELLATION_FREE)) : (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "text-uppercase" }, _T.BOOKING_CANCEL_PERIOD),
                    React.createElement("br", null),
                    penaltyCalculationRules.map((rule, idx) => (React.createElement(React.Fragment, { key: idx },
                        React.createElement("span", { className: "orange-text" },
                            _T.CANCELLATION_FROM,
                            " ",
                            rule.fromString),
                        React.createElement("br", null)))),
                    hasExternalCancellationConditions ? React.createElement("span", { className: "orange-text" }, _T.CANCELLATION_TIMEZONE) : null))),
                React.createElement("td", { className: "ajax-replace", id: "cancelPolicyDescrSum", colSpan: 3 }, (penaltyCalculationRules === null || penaltyCalculationRules === void 0 ? void 0 : penaltyCalculationRules.length) ? (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "text-uppercase" }, _T.CANCELLATION_PENALTY),
                    React.createElement("br", null),
                    penaltyCalculationRules.map((rule, idx) => {
                        var _a, _b;
                        return (React.createElement(React.Fragment, { key: idx },
                            React.createElement("span", { className: "black-text orange-text" },
                                formatMoney(rule.sum, { currency: (_a = rule.currency) === null || _a === void 0 ? void 0 : _a.name }),
                                " ", (_b = rule.currency) === null || _b === void 0 ? void 0 :
                                _b.name),
                            React.createElement("br", null)));
                    }))) : null))))))) : null));
    const renderMakeBookingButton = (className) => (React.createElement("button", { type: "button", className: `btn btn-orange btn-in-table make-booking ${className || ''}`.trim(), disabled: bookingActionDisabled, onClick: () => makeBooking() }, allowChoiceBusPlace ? _T.CHOICE_PLACES_AND_BOOKING_DO : _T.BOOKING_DO));
    const extendedConditionsBlock = showExtendedConditions ? (React.createElement("div", { className: "order-add-point grey1 cart-extended-conditions ajax-replace", id: "cart-extended-conditions" },
        showCancellationConditions ? (React.createElement("div", { className: "info-order mb-2" },
            React.createElement("a", { tabIndex: 0, className: `info-btn ${cancellationConditionsButtonClass}`, role: "button", "data-toggle": "popover", "data-trigger": "focus", "data-placement": "top", "data-tour-hash": tourSearchConditionsHash },
                React.createElement("i", { className: "fa fa-info", "aria-hidden": "true" })),
            cancellationConditionsLabel)) : null,
        booking.prepayment > 0 ? (React.createElement("div", { className: "value-single" },
            React.createElement("span", null,
                _T.BOOKING_PREPAY,
                ":"),
            React.createElement("span", null,
                formatMoney(booking.prepayment, { currency: booking.currency.name }),
                " ",
                booking.currency.name))) : null,
        booking.paymentDate ? (React.createElement("div", { className: "value-single" },
            React.createElement("span", null,
                _T.BOOKING_FULL_PAY_BEFORE,
                ":"),
            React.createElement("span", null, moment(booking.paymentDate).format('L HH:mm')))) : null,
        showCancellationConditions ? (cancellationDenied ? (React.createElement("div", { className: "orange-text" }, _T.HOTEL_NON_CANCEL_TITLE)) : !(penaltyCalculationRules === null || penaltyCalculationRules === void 0 ? void 0 : penaltyCalculationRules.length) ? (React.createElement("div", null, _T.CANCELLATION_FREE)) : (React.createElement(React.Fragment, null, penaltyCalculationRules.map((rule, idx) => {
            var _a, _b;
            return (React.createElement("div", { key: idx },
                React.createElement("span", null,
                    _T.CANCELLATION_FROM,
                    " ",
                    rule.fromString,
                    ":"),
                " ",
                React.createElement("span", { className: "orange-text" },
                    formatMoney(rule.sum, { currency: (_a = rule.currency) === null || _a === void 0 ? void 0 : _a.name }),
                    " ", (_b = rule.currency) === null || _b === void 0 ? void 0 :
                    _b.name)));
        })))) : null)) : null;
    return (React.createElement(CartOrderProvider, { value: {
            booking,
            allTourists,
            errors,
            refresh,
            makeBooking,
            culture: props.culture,
            configuration: props.configuration,
            removeCommonError,
            removeServiceError,
            removeTouristError,
            getTouristFieldMessage,
            setTouristFieldMessage,
            removeTouristFieldMessage,
            addCommonError,
            addServiceError,
            addTouristError,
            //updateService: saveService,
            //updateTourist: saveTourist,
        } },
        React.createElement("div", { className: isExtendedCartPageDesign ? 'react-cart-extended-layout' : 'row m-0' },
            React.createElement("div", { className: isExtendedCartPageDesign ? undefined : 'col-md-12' },
                React.createElement("div", { className: isExtendedCartPageDesign ? 'hotel-body row mx-0 my-4' : '' },
                    React.createElement("div", { className: isExtendedCartPageDesign ? 'px-0 col-md-12' : '' },
                        React.createElement("div", { className: "hotel-panel m-t-10" },
                            React.createElement("h2", { className: "hotel-title" }, _T.BOOKING_YOUR_ORDER),
                            React.createElement("div", { className: "order" },
                                React.createElement("div", { className: `row${isExtendedCartPageDesign ? ' no-gutters' : ''}` },
                                    React.createElement("div", Object.assign({ id: "totalBookingSum", className: "col-md-auto ajax-replace ajax-full-replace", "data-payment": (_d = ((_c = booking.sumToPayRub) !== null && _c !== void 0 ? _c : booking.sumToPay)) === null || _d === void 0 ? void 0 : _d.toFixed(2), "data-prepayment": (_f = ((_e = booking.prepaymentRub) !== null && _e !== void 0 ? _e : booking.prepayment)) === null || _f === void 0 ? void 0 : _f.toFixed(2), "data-currency": booking.prepaymentRub ? 'RUB' : booking.currency.name }, (booking.prepaymentRequired ? { 'data-prepayment-required': true } : {})),
                                        React.createElement("div", { className: `value-general ${!props.configuration.currencySwitchEnabled && booking.costRub ? ' with-rub-price' : ''}` },
                                            React.createElement("span", null,
                                                _T.BOOKING_TOTAL_PRICE,
                                                ":"),
                                            React.createElement("span", null,
                                                formatMoney(booking.cost, { currency: booking.currency.name }),
                                                " ",
                                                booking.currency.name,
                                                !props.configuration.currencySwitchEnabled && booking.costRub ? ` (${booking.costRub} RUB)` : '')),
                                        !isExtendedCartPageDesign && props.user.isAgent ?
                                            React.createElement(React.Fragment, null,
                                                React.createElement("div", { className: "value-single" },
                                                    React.createElement("span", null,
                                                        _T.BOOKING_COMMISSION,
                                                        ":"),
                                                    React.createElement("span", null,
                                                        formatMoney(booking.commission, { currency: booking.currency.name }),
                                                        " ",
                                                        booking.currency.name,
                                                        !props.configuration.currencySwitchEnabled && booking.commissionRub ? ` (${booking.commissionRub} RUB, ${commissionPercent.toFixed()}%)` : ` (${commissionPercent.toFixed()}%)`)),
                                                React.createElement("div", { className: "value-single" },
                                                    React.createElement("span", null,
                                                        _T.BOOKING_TOTAL_TO_PAY,
                                                        ":"),
                                                    React.createElement("span", null,
                                                        formatMoney(booking.sumToPay, { currency: booking.currency.name }),
                                                        " ",
                                                        booking.currency.name,
                                                        !props.configuration.currencySwitchEnabled && booking.sumToPayRub ? ` (${booking.sumToPayRub} RUB)` : ''))) : null,
                                        React.createElement("div", { className: "value-single" },
                                            React.createElement("span", null,
                                                _T.BOOKING_PRICE_PER_PERSON,
                                                ":"),
                                            React.createElement("span", null,
                                                formatMoney(booking.costPerPerson, { currency: booking.currency.name }),
                                                " ",
                                                booking.currency.name,
                                                !props.configuration.currencySwitchEnabled && booking.costPerPersonRub ? ` (${booking.costPerPersonRub} RUB)` : '')),
                                        !isExtendedCartPageDesign && booking.prepayment > 0 ? React.createElement("div", { className: "value-single" },
                                            React.createElement("span", null,
                                                _T.BOOKING_PREPAY,
                                                ":"),
                                            React.createElement("span", null,
                                                formatMoney(booking.prepayment, { currency: booking.currency.name }),
                                                " ",
                                                booking.currency.name,
                                                !props.configuration.currencySwitchEnabled && booking.prepaymentRub ? ` (${booking.prepaymentRub} RUB)` : '')) : null),
                                    React.createElement("div", { className: `col-xs-12 col-md-auto d-flex flex-column${isExtendedCartPageDesign ? ' ml-3' : ''}` },
                                        !isExtendedCartPageDesign ? (React.createElement("div", { className: "info-order" },
                                            React.createElement("a", { tabIndex: 0, className: "info-btn detailed-price top-detailed-price", role: "button", "data-toggle": "popover", "data-placement": "bottom" },
                                                React.createElement("i", { className: "fa fa-info", "aria-hidden": "true" })),
                                            " ",
                                            _T.BOOKING_DETAILED_PRICE)) : null,
                                        React.createElement("div", { className: "info-order" }, !props.configuration.currencySwitchEnabled && booking.costRub ? React.createElement(React.Fragment, null,
                                            React.createElement("span", { tabIndex: 0, className: "info-btn non-interactive" },
                                                React.createElement("i", { className: "fa fa-exclamation", "aria-hidden": "true" })),
                                            " ",
                                            _T.BOOKING_RUBLE_PRICE_DISCLAIMER) : null),
                                        !isExtendedCartPageDesign && showCancellationConditions ? (React.createElement("div", { className: "info-order mb-2" },
                                            React.createElement("a", { tabIndex: 0, className: `info-btn ${cancellationConditionsButtonClass}`, role: "button", "data-toggle": "popover", "data-trigger": "focus", "data-placement": "bottom", "data-tour-hash": tourSearchConditionsHash },
                                                React.createElement("i", { className: "fa fa-info", "aria-hidden": "true" })),
                                            " ",
                                            cancellationConditionsLabel)) : null)),
                                isExtendedCartPageDesign ? (React.createElement("div", { className: "row" },
                                    React.createElement("a", { href: "#", className: "orange-collapse-link d-block", role: "button", "aria-expanded": topDetailedPriceOpen, onClick: e => {
                                            e.preventDefault();
                                            setTopDetailedPriceOpen(open => !open);
                                        } },
                                        React.createElement("span", { className: "caret-control" }, _T.BOOKING_DETAILED_PRICE)),
                                    topDetailedPriceOpen ? (React.createElement("div", { className: "dop-info detailedPrice cart-extended-top-detailed-price" }, renderDetailedPriceSummaryRows())) : null)) : null)))),
                services
                    .filter(s => s.type == 'BookingTourService')
                    .map(s => s)
                    .filter(s => s.allTourServices.filter(ts => ts.type == 'busTransportation').length > 0)
                    .map((s, i) => React.createElement(BusTourService, { key: s.id, service: s, cart: Object.assign(Object.assign({}, props), { booking, tourDescription }), onTouristChange: saveTourist, onTouristsChange: saveTourists, onServiceChange: saveService, deleteService: deleteService, index: i })),
                services
                    .filter(s => s.type == 'BookingTourService')
                    .map(s => s)
                    .filter(s => s.allTourServices.filter(ts => ts.type == 'busTransportation').length == 0)
                    .map((s, i) => React.createElement(TourService, { key: s.id, service: s, cart: Object.assign(Object.assign({}, props), { booking, tourDescription }), onTouristChange: saveTourist, onTouristsChange: saveTourists, onServiceChange: saveService, deleteService: deleteService, index: i })),
                renderStandaloneServiceGroup(hotelServices, (s, i) => {
                    var _a;
                    return React.createElement(HotelService, { key: s.id, service: s, cart: Object.assign(Object.assign({}, props), { booking, tourDescription }), onTouristChange: saveTourist, onTouristsChange: saveTourists, onServiceChange: saveService, deleteService: deleteService, index: i, compulsoryServices: (_a = compulsoryServicesByHotel[getServiceTagKey(s.serviceTag)]) !== null && _a !== void 0 ? _a : [] });
                }),
                renderStandaloneServiceGroup(transferServices, (s, i) => React.createElement(TransferService, { key: s.id, service: s, cart: Object.assign(Object.assign({}, props), { booking, tourDescription }), onTouristChange: saveTourist, onTouristsChange: saveTourists, onServiceChange: saveService, deleteService: deleteService, index: i })),
                renderStandaloneServiceGroup(flightServices, (s, i) => React.createElement(FlightService, { key: s.id, service: s, cart: Object.assign(Object.assign({}, props), { booking, tourDescription }), onTouristChange: saveTourist, onTouristsChange: saveTourists, onServiceChange: saveService, deleteService: deleteService, index: i })),
                renderStandaloneServiceGroup(excursionServices, (s, i) => React.createElement(ExcursionService, { key: s.id, service: s, cart: Object.assign(Object.assign({}, props), { booking, tourDescription }), onTouristChange: saveTourist, onTouristsChange: saveTourists, onServiceChange: saveService, deleteService: deleteService, index: i })),
                renderStandaloneServiceGroup(extraServices, (s, i) => React.createElement(ExtraService, { key: s.id, service: s, cart: Object.assign(Object.assign({}, props), { booking, tourDescription }), onTouristChange: saveTourist, onTouristsChange: saveTourists, onServiceChange: saveService, deleteService: deleteService, index: i }))),
            isExtendedCartPageDesign ? (React.createElement(React.Fragment, null,
                bookingRemarkBlock,
                React.createElement("div", { className: "hotel-body my-4 cart-extended-bottom" },
                    customerDetailsBlock,
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-xs-12 col-md-7" },
                            contactDetailsBlock,
                            policiesBlock),
                        React.createElement("div", { className: "col-xs-12 col-md-5" },
                            React.createElement("div", { className: "cart-extended-total-wrap" },
                                bottomDetailedPriceOpen ? (React.createElement("div", { className: "react-cart-detailed-price-popover" },
                                    React.createElement("div", { className: "react-cart-detailed-price-popover-title" },
                                        React.createElement("span", { tabIndex: 0, className: "info-btn non-interactive" },
                                            React.createElement("i", { className: "fa fa-info", "aria-hidden": "true" })),
                                        React.createElement("span", null, _T.BOOKING_DETAILED_PRICE)),
                                    renderDetailedPriceSummaryRows())) : null,
                                React.createElement("div", { className: "order-add-point grey1 table-responsive cart-extended-total" },
                                    React.createElement("table", { className: "table" },
                                        React.createElement("tr", null,
                                            React.createElement("td", { className: "price-title text-last-right" },
                                                _T.BOOKING_TOTAL_PRICE,
                                                ":")),
                                        React.createElement("tr", null,
                                            React.createElement("td", { className: "price ajax-replace text-last-right", id: "totalBookingSumBottom" },
                                                formatMoney(booking.cost, { currency: booking.currency.name }),
                                                " ",
                                                booking.currency.name)),
                                        props.configuration.currencySwitchEnabled && booking.costRub ? (React.createElement("tr", null,
                                            React.createElement("td", { className: "price ajax-replace text-last-right" },
                                                formatMoney(booking.costRub, { currency: 'RUB' }),
                                                " RUB"))) : null,
                                        React.createElement("tr", null,
                                            React.createElement("td", { className: "info-block text-last-right" },
                                                React.createElement("a", { href: "#", tabIndex: 0, className: "orange-collapse-link bottom-detailed-price d-block", role: "button", "aria-expanded": bottomDetailedPriceOpen, onClick: e => {
                                                        e.preventDefault();
                                                        setBottomDetailedPriceOpen(open => !open);
                                                    } },
                                                    React.createElement("span", { className: "caret-control" }, _T.BOOKING_DETAILED_PRICE))))))))),
                    extendedConditionsBlock,
                    cancellationConditionsBlock,
                    renderMakeBookingButton('w-100')))) : (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "order-add-point grey1 table-responsive" },
                    React.createElement("div", { className: "row no-gutters d-flex align-items-end" },
                        React.createElement("div", { className: "col-xs-12 col-md-6 row no-gutters" }, props.configuration.isProfVersion && !isGagraUI ?
                            React.createElement("table", { className: "table" },
                                React.createElement("tr", null,
                                    React.createElement("td", { rowSpan: 5 },
                                        React.createElement("a", { className: "add-point", href: `${appUrl('/Hotel')}` },
                                            React.createElement("i", { className: "fa fa-plus-square", "aria-hidden": "true" }),
                                            " ",
                                            _T.BOOKING_ADD_HOTEL),
                                        React.createElement("a", { className: "add-point", href: `${appUrl('/Transfer')}` },
                                            React.createElement("i", { className: "fa fa-plus-square", "aria-hidden": "true" }),
                                            " ",
                                            _T.BOOKING_ADD_TRANSFER),
                                        React.createElement("a", { className: "add-point", href: `${appUrl('/Excursion')}` },
                                            React.createElement("i", { className: "fa fa-plus-square", "aria-hidden": "true" }),
                                            " ",
                                            _T.BOOKING_ADD_EXCURSION),
                                        React.createElement("a", { className: "add-point", href: `${appUrl('/Tour')}` },
                                            React.createElement("i", { className: "fa fa-plus-square", "aria-hidden": "true" }),
                                            " ",
                                            _T.BOOKING_ADD_TOUR),
                                        React.createElement("a", { className: "add-point", href: `${appUrl('/Extra')}` },
                                            React.createElement("i", { className: "fa fa-plus-square", "aria-hidden": "true" }),
                                            " ",
                                            _T.BOOKING_ADD_EXTRA)))) : null),
                        React.createElement("div", { className: "col-xs-12 col-md-6 row no-gutters" },
                            React.createElement("table", { className: "table" },
                                React.createElement("tr", null,
                                    React.createElement("td", null),
                                    React.createElement("td", { className: "price-title" },
                                        _T.BOOKING_TOTAL_PRICE,
                                        ":")),
                                React.createElement("tr", null,
                                    React.createElement("td", { colSpan: 2, className: "price ajax-replace", id: "totalBookingSumBottom" },
                                        formatMoney(booking.cost, { currency: booking.currency.name }),
                                        " ",
                                        booking.currency.name)),
                                React.createElement("tr", null,
                                    React.createElement("td", { colSpan: 2 })),
                                React.createElement("tr", null,
                                    React.createElement("td", { colSpan: 2, className: "info-block text-right" },
                                        React.createElement("a", { tabIndex: 0, className: "info-btn detailed-price bottom-detailed-price", role: "button", "data-toggle": "popover", "data-trigger": "focus", "data-placement": "top" },
                                            React.createElement("i", { className: "fa fa-info", "aria-hidden": "true" })),
                                        React.createElement("span", null, _T.BOOKING_DETAILED_PRICE))))))),
                additionalRequirementsBlock,
                customerDetailsBlock,
                contactDetailsBlock,
                policiesBlock,
                cancellationConditionsBlock,
                renderMakeBookingButton())),
            React.createElement("div", { id: "detailedPrice", className: "dont-show ajax-replace detailed-price" },
                React.createElement("div", { className: "services" },
                    Object.values(groupBy(tourServices, s => `${s.tour.id}_${s.begin}`)).map((group, idx) => {
                        const svc = group[0];
                        const total = _.sumBy(group, g => g.priceInBookingCurrency);
                        return (React.createElement("div", { className: "service", key: `tour-${idx}` },
                            React.createElement("div", { className: "type" }, _T.COMMON_TOUR),
                            React.createElement("div", { className: "description" },
                                svc.tour.name,
                                React.createElement("br", null),
                                moment(svc.begin).format('L'),
                                "-",
                                moment(svc.end).format('L')),
                            React.createElement("div", { className: "prices" },
                                React.createElement("div", null,
                                    _T.BOOKING_TOTAL_PRICE,
                                    ": ",
                                    React.createElement("span", null,
                                        formatMoney(total, { currency: booking.currency.name }),
                                        " ",
                                        booking.currency.name)))));
                    }),
                    Object.values(groupBy(hotelServices, s => {
                        const name = `${s.hotel.name}, ${s.hotel.city.name}, ${s.hotel.city.country.name}`;
                        const room = `${getRoomDisplayName(s.hotelPrice.originalRoomName, s.hotelPrice.roomType.name, s.hotelPrice.roomCategory.name)}, ${s.hotelPrice.meal.name}`;
                        return `${s.begin}|${s.end}|${name}|${room}`;
                    })).map((group, idx) => {
                        const svc = group[0];
                        const name = `${svc.hotel.name}, ${svc.hotel.city.name}, ${svc.hotel.city.country.name}`;
                        const room = `${getRoomDisplayName(svc.hotelPrice.originalRoomName, svc.hotelPrice.roomType.name, svc.hotelPrice.roomCategory.name)}, ${svc.hotelPrice.meal.name}`;
                        const nights = Math.max(moment(svc.end).diff(moment(svc.begin), 'days'), 1);
                        const groupTotal = _.sumBy(group, g => g.priceInBookingCurrency);
                        const compSvcs = Object.values(groupBy(compulsoryServices.filter(cs => group.some(g => g.serviceTag == cs.serviceTag)), cs => cs.serviceTag)).map(g => g[0]);
                        const compTotal = _.sumBy(compSvcs, s => s.priceInBookingCurrency);
                        return (React.createElement("div", { className: "service", key: `hotel-${idx}` },
                            React.createElement("div", { className: "type" }, _T.COMMON_HOTEL),
                            React.createElement("div", { className: "description" },
                                name,
                                React.createElement("br", null),
                                room,
                                React.createElement("br", null),
                                _T.COMMON_ROOMS_COUNT,
                                ": ",
                                group.length,
                                React.createElement("br", null),
                                _T.COMMON_NIGHTS_COUNT,
                                ": ",
                                nights,
                                React.createElement("br", null),
                                moment(svc.begin).format('L'),
                                "-",
                                moment(svc.end).format('L')),
                            React.createElement("div", { className: "prices" },
                                React.createElement("div", null,
                                    _T.CART_AVG_NIGHT_PRICE,
                                    ": ",
                                    React.createElement("span", null,
                                        formatMoney(groupTotal / (nights * group.length), { currency: booking.currency.name }),
                                        " ",
                                        booking.currency.name)),
                                compSvcs.map((cs, csIdx) => (React.createElement("div", { key: csIdx },
                                    cs.compulsoryService._rules.name,
                                    ": ",
                                    React.createElement("span", null,
                                        formatMoney(cs.priceInBookingCurrency, { currency: booking.currency.name }),
                                        " ",
                                        booking.currency.name)))),
                                React.createElement("div", null,
                                    _T.COMMON_TO_PAY,
                                    ": ",
                                    React.createElement("span", null,
                                        formatMoney(groupTotal + compTotal, { currency: booking.currency.name }),
                                        " ",
                                        booking.currency.name)))));
                    }),
                    Object.values(groupBy(transferServices, s => { var _a; return `${s.begin}|${((_a = s.transferPrice) === null || _a === void 0 ? void 0 : _a.name) || ''}`; })).map((group, idx) => {
                        var _a;
                        const svc = group[0];
                        return (React.createElement("div", { className: "service", key: `transfer-${idx}` },
                            React.createElement("div", { className: "type" }, _T.COMMON_TRANSFER),
                            React.createElement("div", { className: "description" }, (_a = svc.transferPrice) === null || _a === void 0 ? void 0 :
                                _a.name,
                                React.createElement("br", null),
                                moment(svc.begin).format('L')),
                            React.createElement("div", { className: "prices" },
                                React.createElement("div", null,
                                    _T.COMMON_TO_PAY,
                                    ": ",
                                    React.createElement("span", null,
                                        formatMoney(_.sumBy(group, g => g.priceInBookingCurrency), { currency: booking.currency.name }),
                                        " ",
                                        booking.currency.name)))));
                    }),
                    flightServices.map((svc, idx) => {
                        var _a, _b, _c, _d;
                        return (React.createElement("div", { className: "service", key: `flight-${idx}` },
                            React.createElement("div", { className: "type" }, displayFlightAsTransportation ? _T.COMMON_TRANSPORTATION : _T.COMMON_FLIGHT),
                            React.createElement("div", { className: "description" },
                                ((_b = (_a = svc.cityFrom) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : ''),
                                " \u2192 ",
                                ((_d = (_c = svc.cityTo) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : ''),
                                React.createElement("br", null),
                                moment(svc.begin).format('L'),
                                svc.flightNumber ? React.createElement(React.Fragment, null,
                                    React.createElement("br", null),
                                    _T.FLIGHT_NUMBER,
                                    ": ",
                                    svc.flightNumber) : null),
                            React.createElement("div", { className: "prices" },
                                React.createElement("div", null,
                                    _T.COMMON_TO_PAY,
                                    ": ",
                                    React.createElement("span", null,
                                        formatMoney(svc.priceInBookingCurrency, { currency: booking.currency.name }),
                                        " ",
                                        booking.currency.name)))));
                    }),
                    Object.values(groupBy(excursionServices, s => `${s.begin}|${s.name}|${s.excursionProgramPrice ? 1 : 0}`)).map((group, idx) => {
                        const svc = group[0];
                        const isProgram = !!svc.excursionProgramPrice;
                        return (React.createElement("div", { className: "service", key: `excursion-${idx}` },
                            React.createElement("div", { className: "type" }, isProgram ? _T.COMMON_EXCURSION_PROGRAM : _T.COMMON_EXCURSION),
                            React.createElement("div", { className: "description" },
                                svc.name,
                                React.createElement("br", null),
                                moment(svc.begin).format('L')),
                            React.createElement("div", { className: "prices" },
                                React.createElement("div", null,
                                    _T.COMMON_TO_PAY,
                                    ": ",
                                    React.createElement("span", null,
                                        formatMoney(_.sumBy(group, g => g.priceInBookingCurrency), { currency: booking.currency.name }),
                                        " ",
                                        booking.currency.name)))));
                    })),
                React.createElement("div", { className: "total" },
                    React.createElement("table", { className: "w-100" },
                        React.createElement("thead", { className: "detailed-price-total-xs-invisible" },
                            React.createElement("tr", null,
                                React.createElement("th", null,
                                    React.createElement("div", null, detailedPriceHeaders[0] || '')),
                                React.createElement("th", null,
                                    React.createElement("div", null, detailedPriceHeaders[1] || '')),
                                React.createElement("th", null,
                                    React.createElement("div", null, detailedPriceHeaders[2] || '')))),
                        React.createElement("tbody", null,
                            React.createElement("tr", null,
                                React.createElement("th", null,
                                    React.createElement("span", { className: "detailed-price-total-xs-only-visible" }, detailedPriceHeaders[1] || '')),
                                React.createElement("td", null,
                                    formatMoney(booking.cost, { currency: booking.currency.name }),
                                    " ",
                                    booking.currency.name),
                                React.createElement("td", { className: "detailed-price-total-xs-invisible" },
                                    formatMoney(booking.costPerPerson, { currency: booking.currency.name }),
                                    " ",
                                    booking.currency.name)),
                            React.createElement("tr", { className: "detailed-price-total-xs-only-visible" },
                                React.createElement("th", null,
                                    React.createElement("span", null, detailedPriceHeaders[2] || '')),
                                React.createElement("td", { className: "detailed-price-total-xs-invisible" },
                                    formatMoney(booking.cost, { currency: booking.currency.name }),
                                    " ",
                                    booking.currency.name),
                                React.createElement("td", null,
                                    formatMoney(booking.costPerPerson, { currency: booking.currency.name }),
                                    " ",
                                    booking.currency.name)),
                            props.user.isAgent ? React.createElement(React.Fragment, null,
                                React.createElement("tr", { style: { minHeight: 8, height: 8 } }),
                                React.createElement("tr", null,
                                    React.createElement("th", null,
                                        _T.BOOKING_AGENTS_COMMISSION,
                                        ":"),
                                    React.createElement("td", { colSpan: 2 },
                                        formatMoney(booking.commission, { currency: booking.currency.name }),
                                        " ",
                                        booking.currency.name,
                                        " (",
                                        commissionPercent.toFixed(0),
                                        "%)")),
                                React.createElement("tr", null,
                                    React.createElement("th", null,
                                        _T.BOOKING_COMMISSION_SERVICES,
                                        ":"),
                                    React.createElement("td", { colSpan: 2 },
                                        formatMoney(commissionServicesCost, { currency: booking.currency.name }),
                                        " ",
                                        booking.currency.name)),
                                React.createElement("tr", null,
                                    React.createElement("th", null,
                                        _T.BOOKING_NON_COMMISSION_SERVICES,
                                        ":"),
                                    React.createElement("td", { colSpan: 2 },
                                        formatMoney(nonCommissionServicesCost, { currency: booking.currency.name }),
                                        " ",
                                        booking.currency.name))) : null)))),
            React.createElement(FlightSchemeModal, { booking: booking, onServiceChange: saveService, onMakeBooking: makeBooking, allowSkipPlaceSelection: props.configuration.allowBookingBusTourWithoutChoosingPlace, onSkipPlaceSelection: () => makeBooking(undefined, { skipPlaceSelectionPrompt: true, clearPlaceSelection: true }) }),
            React.createElement(Modal, { open: paymentFormOpen, onClose: (e, r) => {
                    setPaymentFormOpen(false);
                    if (!placeSelectionSkippedRef.current)
                        document.dispatchEvent(new CustomEvent('busSchemeModalRequested', { detail: { source: 'cart-order' } }));
                } },
                React.createElement("div", { className: "modal-dialog modal-lg modal-xl" },
                    React.createElement("div", { className: "modal-content custom-modal-content" },
                        React.createElement("div", { id: "payment-ui-container" },
                            React.createElement(PaymentForm, { agentAcquiringPercentByCard: (_g = window.__agentAcquiringPercentByCard) !== null && _g !== void 0 ? _g : 0, agentAcquiringPercentBySbp: (_h = window.__agentAcquiringPercentBySbp) !== null && _h !== void 0 ? _h : 0, agentAcquiringPercentBySbpLegal: (_j = window.__agentAcquiringPercentBySbpLegal) !== null && _j !== void 0 ? _j : 0, allowPayingLater: booking.prepayment == 0 || !booking.prepaymentRequired, allowPartialPayment: booking.prepayment < booking.sumToPay, prepaymentAmount: booking.prepayment, paymentAmount: booking.sumToPay, currencyName: booking.currency.name, location: 'CartOnly', onInitialized: () => { }, onCancel: () => {
                                    setPaymentFormOpen(false);
                                    if (!placeSelectionSkippedRef.current)
                                        document.dispatchEvent(new CustomEvent('busSchemeModalRequested', { detail: { source: 'cart-order' } }));
                                }, onSuccess: (p) => __awaiter(this, void 0, void 0, function* () {
                                    var _p;
                                    let model = sanitizeModelFlightPlaces(getCartOrderBookingUpdateModel());
                                    if (placeSelectionSkippedRef.current)
                                        model = clearPlaceSelectionInModel(model);
                                    else if ((_p = pendingFlightPlaceUpdatesRef.current) === null || _p === void 0 ? void 0 : _p.length)
                                        model = applyFlightPlaceUpdatesToModel(model, pendingFlightPlaceUpdatesRef.current);
                                    if (yield validateCart(model))
                                        continueBooking(model, p);
                                    else {
                                    }
                                }), userType: props.user.isAgent ? 'agent' : 'personal' }))))))));
}
